<template>
  <div class="row">
    <div class="col-12 mb-4">
      <v-card>
        <v-card-title>
          {{ $t('categoriesclients.management') }}
          <v-spacer></v-spacer>
          <v-text-field solo
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
            :headers="headers"
            :items="categories"
            :search="search"
            sort-by="name"
            class="elevation-1"
            :loading="!categories" loading-text="Chargement en cours..."
        >

          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn style="background: #29B3A6;color: #fff" class="mb-2" v-on="on">
                    {{ $t('categoriesclients.new') }}
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text>
                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field solo v-model="client_category._nom"
                                      :label="$t('categoriesclients.category')"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="12">
                        <v-textarea solo v-model="client_category._description"
                                      :label="$t('categoriesclients.category')"></v-textarea>
                      </v-col>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" @click="close">Annuler</v-btn>
                    <v-btn color="primary" @click="save">Enrégistrer</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <div style="text-align:  right">
              <v-menu
                  key="text"
                  rounded="b-xl">
                <template v-slot:activator="{ attrs, on }">

                  <v-icon

                      class="black--text "
                      v-bind="attrs"
                      v-on="on">mdi-dots-vertical
                  </v-icon>

                </template>
                <v-list>
                  <v-list-item
                      v-for="(action_item, index) in actions_items"
                      :key="index"
                      link
                      @click="editItemAction(item,index)">
                    <v-list-item-icon>
                      <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="action_item.title"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
          <template v-slot:no-data>
            {{ $t('no_data') }}
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import helpers from "../../mixins/helpers";
import {mapState} from "vuex";
export default {
  name: "ClientCategories",
  mixins:[helpers(this)],
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$t('categoriesclients.new') : this.$t('categoriesclients.update')
    },
    ...mapState('clientcategory/',['clientcategories'])
  },
  data() {
    return {
      valid: true,
      lazy: false,
      search: '',
      dialog: false,
      id: undefined,
      editedIndex: -1,
      errors: undefined,
      headers: [
        {text: 'Icone', value: '_icon'},
        {
          text: 'Nom',
          align: 'start',
          sortable: true,
          value: '_name',
        },
        {text: 'Description', value: '_description'},
        {text: 'Marchand', value: '_marchand_id'},
        {text: 'Compte Business', value: '_business_account_id'},
        {text: '', value: 'actions', sortable: false},
      ],
      actions_items: [
        {title: "Régions", avatar: 'mdi mdi-view-list'},
        {title: "Modifier", avatar: 'mdi-pencil'},
        {title: "Supprimer", avatar: 'mdi-delete'}
      ],
      client_category: {
        _nom: "",
        _description: "",
        _icon: null
      }
    }
  },
  methods: {
    save() {
      this.submitting = true;
      let self = this;
      let data = new FormData()
      data.append("name", this.client_category._nom);
      data.append("description", this.client_category._description);
      let mineroute = 'clientcategory/newCategory';
      if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id)
                    mineroute = 'countries/updateCountry';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    this.submitting = false;
                    if (response.data.error) {
                        self.toast('error',response.data.message)
                    } else {

                        self.toast('success',response.data.message)
                    }
                    self.close();
                })
    }
  }
}
</script>

<style scoped>

</style>
